import EntityWithNameStore from "./EntityWithNameStore"

const timeZoneGroupStore = new EntityWithNameStore();
export default timeZoneGroupStore;


// WEBPACK FOOTER //
// ./web/js/store/timeZoneGroupStore.js